// Could use this for adding a function when the window is loader, so it can recognize the id of them

export const animationbar = () => {
  let login = document.getElementById("login");
  let signup = document.getElementById("signup");
  let bar = document.getElementById("bar");
  let loginform = document.getElementById("loginform");
  let signupform = document.getElementById("signupform");
  

  const loginClick = () => {
    bar.style.left = "25%";
    login.style.color = "white";
    login.style.fontWeight = "bold";

    signup.style.color = "#181818";
    signup.style.fontWeight = "normal";

    // Move the sign in form to the right place
    signupform.style.left = "1200px";
    signupform.style.top = "100px";

    // Move the login form to the right place
    loginform.style.left = "0px";
    loginform.style.top = "0px";
  };

  const signupClick = () => {
    bar.style.left = "50%";
    signup.style.color = "white";
    signup.style.fontWeight = "bold";

    login.style.color = "#181818";
    login.style.fontWeight = "normal";

    // Move the signup form to the right place

    signupform.style.left = "0px";
    signupform.style.top = "50px";

    // Move the login form to the right place

    loginform.style.left = "-3000px";
    loginform.style.top = "100px";
  }; 


  login.addEventListener("click", loginClick);
  signup.addEventListener("click", signupClick);
};